<template>
	<div class="showcase-app__filter">
		<label :for="filterName" class="showcase-app__filter-label"><slot name="filterTitle"></slot></label>
		<select class="custom-select" :name="filterName" :id="filterName" v-model="selectedValue" @change="filterChange">
			<option v-for="filterOption in filterOptions" :value="filterOption.Key">{{ filterOption.Value }}</option>
		</select>
	</div>
</template>

<script lang="ts">

export default {
	name: "ShowcaseFilter",
	data: () => {
		return {
			selectedValue: "",
		}
	},
	props: {
		filter: {
			type: String,
			default: ""
		},
		filterOptions: {
			type: Array,
			default: () => []
		},
	},
	computed: {
		filterName: function() {
			return this.slugify(this.filter);
		},
	},
	methods: {
		//when the filter changes emit the filter and the value of the filter back to parent
		filterChange(value) {
			let passedValues = [this.filter, this.selectedValue];
			this.$emit('filterChange', passedValues);
		},
		//ensure the filter passed in is sluggified to be used as ID and For to connect label to select
		slugify(value) {
			return value.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
		}
	},
	created() {
		//set selected values from params if available
		if(this.filter === 'ShowcaseStyle' && new URLSearchParams(window.location.search).get('showcaseStyle')) {
			this.selectedValue = new URLSearchParams(window.location.search).get('showcaseStyle');
		}
		if(this.filter === 'Portfolio' && new URLSearchParams(window.location.search).get('portfolio')){
			this.selectedValue = new URLSearchParams(window.location.search).get('portfolio');
		}
	}
};
</script>
